import { CheckCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import { GreenColors } from '@/theme';

export const ExportConfirmIcon = styled(CheckCircleOutlined)`
  color: ${GreenColors[60]} !important;
`;
